import React from "react"

export function CheckMark({
  fill = "#FF46AA",
  h = 12,
  w = 16,
  className,
}: {
  fill?: string
  h?: number | string
  w?: number | string
  className?: string
}) {
  return (
    <svg className={className} width={w} height={h} viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.59442 11.3732L0.719416 6.49821C0.426536 6.20533 0.426536 5.73046 0.719416 5.43755L1.78005 4.37689C2.07293 4.08398 2.54783 4.08398 2.84072 4.37689L6.12475 7.66089L13.1588 0.626887C13.4517 0.334006 13.9266 0.334006 14.2194 0.626887L15.2801 1.68755C15.573 1.98043 15.573 2.4553 15.2801 2.74821L6.65508 11.3732C6.36217 11.6661 5.8873 11.6661 5.59442 11.3732Z"
        fill={fill}
      />
    </svg>
  )
}
